// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"3a25e5a6","480":"a7ebb3d1","838":"580e6b4f"}[chunkId] + ".js";
};